import SvgIcon from './src/SvgIcon'

SvgIcon.install = function (Vue) {
    Vue.component(SvgIcon.name, SvgIcon)
}

export default SvgIcon